module.exports = __webpack_public_path__ + "static/media/icon_83.2e05ffbf.svg";